module.exports = __webpack_public_path__ + "static/mirage.99e61545.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/mirage.mp4
// module id = 727
// module chunks = 35783957827783